export default "__VITE_ASSET__uLnrKaB8__"